
import { Vue, Component, Prop, ModelSync } from "vue-property-decorator";
import { Control } from "@/oxygen/classes/lib/types";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import FocusPointInput from "@/components/Reusable/CustomInputs/FocusPointInput/FocusPointInput.vue";

@Component({
  components: {
    FocusPointInput,
    TextInput
  }
})
export default class OxygenUnitInput extends Vue {
  @Prop()
  control!: Control;

  @ModelSync("value", "input", { type: Object })
  syncedValue?: string;
}
